/*eslint-disable */
// import SpcmModel from '../../Model/Spcm'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility"
import SpcmAnalyticsCaseSummary from '../../views/Gide/SPCM/SpcmAnalyticsCaseSummary.vue';

let Spcms = {
  /**
   * spcmList
   */
  async spcmList (context, whereFilter=null) {
    Utility.showLoader = true;
    Utility.loadingMsg = "Please wait....";   
    try{
      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "spcm_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch (err) {
      console.error('Exception occurred at spcmList() and Exception:', err.message)
    }
    finally {
      Utility.showLoader = false;
    }
  },

  /**
   * spcmStateList
   */
  async spcmStateList (context, whereFilter=null) {
    try{
      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "spcm_state_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch (err) {
      console.error('Exception occurred at spcmStateList() and Exception:', err.message)
    }
  },    

  /**
   * spcmView
   */
  async spcmView (context, spcmId=null, gide_user_id=null) {
    try {      
      let post_data = new FormData();
      if (spcmId) {
        post_data.append('spcm_id', spcmId);
      }

      if (gide_user_id) {
        post_data.append('gide_user_id', gide_user_id);
      }

      return await request.curl(context, "spcm_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at spcmView() and Exception:",err.message)
    }    
  },

  /**
   * spcmAdd
   */
  async spcmAdd (context, spcmObj) {
    try{
      let post_data = new FormData();
    
      for (let key in spcmObj) {
        if (spcmObj[key] || typeof spcmObj[key] == "number") {
          post_data.append(key, spcmObj[key]);
        }
      }

      return await request.curl(context, "spcm_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch (err) {
      console.error('Exception occurred at spcmAdd() and Exception:', err.message)
    }
  },

  /**
   * spcmStudentPublicReg
   */
   async spcmStudentPublicReg (context, spcmObj) {
    try{
      let post_data = new FormData();
    
      for (let key in spcmObj) {
        if (spcmObj[key] || typeof spcmObj[key] == "number") {
          post_data.append(key, spcmObj[key]);
        }
      }

      return await request.curl(context, "spcm_student_counsellor_public_registration", post_data)
      .then(async response => {
          return response;
      });
    }
    catch (err) {
      console.error('Exception occurred at spcmStudentPublicReg() and Exception:', err.message)
    }
  },

  /**
   * spcmEdit
   */
  async spcmEdit (context, spcmObj) {
    try{
      let post_data = new FormData();

      let s3Attachments = []
      for (let key in spcmObj) 
        if( key === 'spcm_contract' && spcmObj.spcm_contract && spcmObj.spcm_contract.length ){
          for (const attachment of spcmObj.spcm_contract) {
            if (attachment.url && attachment.url.includes('amazonaws.com')) {
              // if file is already uploaded
              s3Attachments.push(attachment);
              continue
            }
            post_data.append(key, attachment);
         }
       }
       else {
         if (spcmObj[key] || typeof spcmObj[key] == "number") {
           post_data.append(key, spcmObj[key]);
         }
      }
      post_data.append('s3Attachments', JSON.stringify(s3Attachments))

      return await request.curl(context, "spcm_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch (err) {
      console.error('Exception occurred at spcmEdit() and Exception:',err.message)
    }
  },

  /**
   * spcmDelete
   */
  async spcmDelete (context, spcmId) {
    try{
      let post_data = new FormData();
      
      post_data.append('spcm_id', spcmId);

      return await request.curl(context, "spcm_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch (err) {
      console.error('Exception occurred at spcmDelete() and Exception:',err.message)
    }
  },

  /**
   * spcm Category Edit
   *
   */
  async spcmCategoryEdit (context, payload) {
    try {
      let post_data = new FormData();

      for (let key in payload) {
        if (payload[key] || key == 'history') {
          post_data.append(key, payload[key]);
        }
      }

      return await request.curl(context, "spcm_category_edit", post_data) // spcm_category_edit
        .then(async response => {
          return response
        });
    }
    catch (err) {
      console.error('Exception occurred at spcmCategoryEdit() and Exception:',err.message)
    }
  },

  /**
   * spcm Strategist Edit
   *
   */
  async spcmStrategistEdit (context, userObj) {
    try {
      let post_data = new FormData();

      for (let key in userObj) {
        if (userObj[key] || key == 'history') {
          post_data.append(key, userObj[key]);
        }
      }

      return await request.curl(context, "spcm_strategist_edit", post_data) // spcm_strategist_edit
        .then(async response => {
          return response
        });
    }
    catch (err) {
      console.error('Exception occurred at spcmStrategistEdit() and Exception:',err.message)
    }
  },

  /**
    * Student Counselor Team List
    */
  async StudentCounselorTeamList (context, whereFilter = null) {
    try{
      let post_data = new FormData();
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "spcm_student_counselor_team_list", post_data)
      .then(async response => {
        return response
      });
    }
    catch(err){
      console.error('Exception occurred at StudentCounselorTeamList() and Exception:',err.message)
    }
  },

 /**
    * Student Counselor Team Edit
    */
  async spcmStudentCounselorTeamEdit (context, payload) {
    try{
      let post_data = new FormData();
      for (let key in payload) {
        if (payload[key]) {
          post_data.append(key, payload[key]);
        }
      }

      return await request.curl(context, "spcm_student_counselor_team_edit", post_data)
      .then(async response => {
        return response
      });
    }
    catch(err){
      console.error('Exception occurred at spcmStudentCounselorTeamEdit() and Exception:',err.message)
    }
  },

  /**
    * Student MS Country Strategy Team Edit
    */
  async spcmStudentCountryStrategyEdit (context, payload) {
    try{
      let post_data = new FormData();
      for (let key in payload) {
        if (payload[key]) {
          post_data.append(key, payload[key]);
        }
      }

      return await request.curl(context, "spcm_student_country_strategy_edit", post_data)
      .then(async response => {
        return response
      });
    }
    catch(err){
      console.error('Exception occurred at spcmStudentCountryStrategyEdit() and Exception:',err.message)
    }
  },

 /**
   * spcmCategoryList
   */
  async spcmCategoryList (context, whereFilter=null) {
    try{
      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "spcm_category_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch (err) {
      console.error('Exception occurred at spcmCategoryList() and Exception:',err.message)
    }
  },

  /**
   * SpcmAnalyticsCaseSummary
   */
  async SpcmAnalyticsCaseSummary (context, spcmObj={}) {   
    try{
      let post_data = new FormData();  
      for (let key in spcmObj) {
        if (key === 'whereFilter' && spcmObj[key]) {
          post_data.append('filter', JSON.stringify(spcmObj[key]))
        }
        else if (spcmObj[key] || typeof spcmObj[key] == "number") {
          post_data.append(key, spcmObj[key]);
        }
      }

      return await request.curl(context, "spcm_analytics_case_summary", post_data)
        .then(async response => {
          return response
        });
    }
    catch (err) {
      console.error('Exception occurred at SpcmAnalyticsCaseSummary() and Exception:',err.message)
    }
  },

  /**
   * spcmCounselorStudentsList
   */
  async spcmCounselorStudentsList (context, whereFilter=null) {
    Utility.showLoader = true;
    Utility.loadingMsg = "Please wait....";   
    try{
      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "spcm_analytics_counselor_students", post_data)
        .then(async response => {
          return response
        });
    }
    catch (err) {
      console.error('Exception occurred at spcmCounselorStudentsList() and Exception:',err.message)
    }
    finally {
      Utility.showLoader = false;
    }
  },

  /**
   * spcmAnalyticsStudentMeeting
   */
  async spcmAnalyticsStudentMeeting (context, payload={}) {
    Utility.showLoader = true;
    Utility.loadingMsg = "Please wait....";   
    try{

      let postData = new FormData();
      for (let key in payload) {
        if (key == "whereFilter") {
          postData.append("filter", JSON.stringify(payload[key]))
        }
        else if (payload[key] || typeof payload[key] == "number") {
          postData.append(key, payload[key])
        }
      }

      return await request.curl(context, "spcm_analytics_student_meetings", postData)
        .then(async response => {
          return response
        });
    }
    catch (err) {
      console.error('Exception occurred at spcmCounselorStudentsList() and Exception:',err.message)
    }
    finally {
      Utility.showLoader = false;
    }
  },

  /**
   * spcmAnalyticsCounselorMeeting
   */
  async spcmAnalyticsCounselorMeeting (context, payload={}) {
    Utility.showLoader = true;
    Utility.loadingMsg = "Please wait....";
 
    try{

      let postData = new FormData();
      for (let key in payload) {
        if (key == "whereFilter") {
          postData.append("filter", JSON.stringify(payload[key]))
        }
        else if (payload[key] || typeof payload[key] == "number") {
          postData.append(key, payload[key])
        }
      }

      return await request.curl(context, "spcm_analytics_counselor_meetings", postData)
      .then(async response => {
        return response
      });
    }
    catch (err) {
      console.error('Exception occurred at spcmAnalyticsCounselorMeeting() and Exception:',err.message)
    }
    finally {
      Utility.showLoader = false;
    }
  },

  /**
   * spcmApprove
   */
  async spcmApprove (context, spcmObj) {
    try{
      let post_data = new FormData();    
      for (let key in spcmObj) {
        post_data.append(key, spcmObj[key]);
      }

      return await request.curl(context, "spcm_approve", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at spcmApprove() and Exception:',err.message)
    }
  },

  /**
   * spcm State Edit
   */
  async spcmStateEdit (context, payload) {
    try {
      let post_data = new FormData();
      for (let key in payload) {
        if (payload[key] || typeof payload[key] == "number" || key == 'history') {
          post_data.append(key, payload[key]);
        }
      }

      return await request.curl(context, "spcm_state_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch (err) {
      console.error('Exception occurred at spcmStateEdit() and Exception:', err.message);
    }
  },

   /**
    * Student University list Edit
    */
  async spcmStudentUniversityEdit (context, payload) {
    try{
      let post_data = new FormData();
      for (let key in payload) {
        if (payload[key]) {
          post_data.append(key, payload[key]);
        }
      }

      return await request.curl(context, "spcm_student_university_edit", post_data)
      .then(async response => {
        return response
      });
    }
    catch(err){
      console.error('Exception occurred at spcmStudentUniversityEdit() and Exception:',err.message)
    }
  },

}

export {
  Spcms
}
